export default "__VITE_ASSET__OINgWJm9__"